import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import BaseModal from 'components/Modals/BaseModal'
import { Form, Button, DateTimePicker } from 'components/Forms'
import { Alert } from 'ui'

import { exportPdfMySchedule } from 'services/schedule'
import { closeModal } from 'store/actions/modals'

const ScheduleExportPDFModal = ({ range = [], employeeId }) => {
  const dispatch = useDispatch()
  //get the connected user
  const { _id } = useSelector(state => state.users.userInfo)
  const userId = employeeId || _id

  // Form validation
  let bulletinShape = {
    range: Yup.array(Yup.string())
  }

  const onSubmit = values => {
    exportPdfMySchedule(userId, values.range)
    dispatch(closeModal())
  }

  return (
    <BaseModal hideButtons title={`employee.mySchedule.EXPORT_SCHEDULE`}>
      <div className="mt-2">
        <Formik
          validationSchema={Yup.object().shape(bulletinShape)}
          enableReinitialize={true}
          onSubmit={onSubmit}
          initialValues={{
            range
          }}
        >
          {({ isSubmitting, status, setStatus }) => {
            return (
              <Form>
                {() => (
                  <>
                    {/* Error message */}
                    <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                      {status?.msg}
                    </Alert>
                    <DateTimePicker module="employee.mySchedule" name="range" required type="range" key="range" />
                    {/* Submit & Close buttons */}
                    <div className="mt-4">
                      <Button type="submit" isSubmitting={isSubmitting} text="EXPORT_PDF" />
                      <Button text="actions.CLOSE" className="btn btn-outline-secondary ml-2" onClick={() => dispatch(closeModal())} />
                    </div>
                  </>
                )}
              </Form>
            )
          }}
        </Formik>
      </div>
    </BaseModal>
  )
}

export default ScheduleExportPDFModal
